import BaseDropdown, { DropdownItem as BaseDropdownItem } from "@common/components/Dropdown/Dropdown";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import * as Icon from "@public/pages/shared/icons/icons";
import styled, { css } from "styled-components";

export const TicketDetailsBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2.8rem;
  margin-bottom: 4rem;
  align-items: center;
`;

export const StatusPriorityDropdown = styled(BaseDropdown)`
  background: ${vars.colors.grey100};
  border: 1px solid ${vars.colors.grey90};
  border-radius: 1rem;
  cursor: not-allowed;

  > div:first-child {
    padding: 1rem;
  }

  span {
    text-color: ${vars.colors.grey30};
    white-space: nowrap;
  }
`;

export const AssigneeDropdown = styled(BaseDropdown)`
  cursor: not-allowed;
  span {
    margin-right: 0;
  }
`;

export const DropdownItem = styled(BaseDropdownItem)<{ $clicked?: boolean }>`
  ${(props) =>
    props.$clicked &&
    css`
      background: ${vars.colors.grey90};
    `}

  p {
    color: ${vars.colors.grey50};
    max-width: 22rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1.4rem;
`;

export const Checkmark = styled.div`
  margin-right: 0.8rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
`;

export const CheckmarkIcon = styled(Icon.CheckmarkIcon)`
  path {
    stroke: ${vars.colors.white};
  }
`;

export const DeleteMergeContainer = styled.div`
  height: 4rem;
  border-radius: 1rem;
  border: 1px solid ${vars.colors.grey90};
  background: ${vars.colors.grey100};
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const DuplicateContainer = styled.div`
  // cursor: pointer;
  // Disabled
  opacity: 0.6;
  cursor: not-allowed;
  span {
    opacity: 0.6;
    &:hover {
      opacity: 0.6;
    }
  }

  svg {
    margin: 0.8rem;
    width: 2rem;
    height: 2rem;
  }
  position: relative;
`;

export const DeleteContainer = styled.div`
  justify-content: center;
  // cursor: pointer;

  // Disabled
  opacity: 0.6;
  cursor: not-allowed;
  span {
    opacity: 0.6;
    &:hover {
      opacity: 0.6;
    }
  }
`;

export const ShareTicketContainer = styled.div`
  height: 4rem;
  border-radius: 1rem;
  border: 1px solid ${vars.colors.grey90};
  display: flex;
  align-items: center;
  padding: 0 1rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ShareTicketText = styled(Paragraph)`
  color: ${vars.colors.grey50};
  font-size: 1.2rem;
  white-space: nowrap;
`;

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.2rem;
  margin-left: 0.2rem;
  cursor: pointer;
`;
